import type { IOrdersEdgesNode } from "@repo/shopify/src/queries/customer-gql";
import React from "react";
import { useTranslation } from "react-i18next";

function TrackingNumber({ order }: { order: IOrdersEdgesNode }) {
  const orderProcessing = order.fulfillmentStatus === "FULFILLED" || "PARTIALLY_FULFILLED"; // 주문 처리 상태

  const trackingNumbers =
    orderProcessing &&
    order.successfulFulfillments?.flatMap((fulfillment) => fulfillment.trackingInfo.map((info) => info.number));
  // TODO: 기존에 사용하던 api 서비스 종료로 인해 대체함, 비젬에도 수정 요청 필요
  // const trackingUrls =
  //   orderProcessing &&
  //   order.successfulFulfillments?.flatMap((fulfillment) => fulfillment.trackingInfo.map((info) => info.url));

  const { t } = useTranslation();

  return (
    <div className="pointer-events-auto flex gap-1">
      <span>{t("account.order.invoice_number")}:</span>
      {trackingNumbers && trackingNumbers.length > 0
        ? trackingNumbers.map((trackingNumber, index) => {
            const trackingUrl = `https://trace.cjlogistics.com/next/tracking.html?wblNo=${trackingNumber}`;
            return (
              <React.Fragment key={trackingNumber}>
                {trackingUrl ? (
                  <a
                    className="underline"
                    href={trackingUrl}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    rel="noreferrer"
                    target="_blank"
                  >
                    {trackingNumber}
                  </a>
                ) : (
                  <span>{trackingNumber}</span>
                )}
                {index < trackingNumbers.length - 1 && ","}
              </React.Fragment>
            );
          })
        : null}
    </div>
  );
}

export default TrackingNumber;
